var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('router-view'),_vm._v(" "),_c('m-dialog',_vm._b({on:{"emit_close":_vm.emit_alertClose,"emit_ok":_vm.emit_alertOk}},'m-dialog',{
            model: 'alert',
            isShow: _vm.alert_isShow,
            content: _vm.alert_data.content
        },false)),_vm._v(" "),_c('m-dialog',_vm._b({on:{"emit_close":_vm.emit_confirmClose,"emit_ok":_vm.emit_confirmOk}},'m-dialog',{
            model: 'confirm',
            isShow: _vm.confirm_isShow,
            content: _vm.confirm_data.content
        },false)),_vm._v(" "),_c('m-dialog',_vm._b({on:{"emit_close":_vm.emit_titleConfirmClose,"emit_ok":_vm.emit_titleConfirmOk}},'m-dialog',{
            model: 'titleConfirm',
            isShow: _vm.titleConfirm_isShow,
            title: _vm.titleConfirm_data.title,
            content: _vm.titleConfirm_data.content,
            btnCancelText: _vm.titleConfirm_data.btnCancelText,
            btnTrueText: _vm.titleConfirm_data.btnTrueText
        },false))],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-05f3461d","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = null
// module chunks = 